import React from 'react';
import Header from './Header';

// Sidebar removida; navegação migrou para o Header
const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="flex min-w-0">
        <main className="flex-1 p-6 min-w-0">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full min-w-0 overflow-x-hidden">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
